import React, { useState, useEffect, useRef } from 'react';
import FloatingPicker from "../FloatingPicker";
import { pick } from "../../../modules/utils";
import { buildDate, datePickerDateOptions, dateInputValue } from "../../../modules/dates";
function getDateValue(resource, name, defaultDate) {
    let date = defaultDate;
    if (resource && resource[name]) {
        date = resource[name];
    }
    if (typeof date !== 'string') {
        return date;
    }
    if (date.indexOf('-') >= 0) {
        return new Date(date);
    } // Sometimes we'll receive a date as a string we can't just pass to the Date constructor:
    const parts = date.split(' ').reverse();
    const year = parts[0];
    const month = parseInt(parts[1], 10) - 1; // Months are counted from 0
    const day = parts[2];
    return new Date(Number(year), month, Number(day), 0, 0, 0, 0);
}
function getStateFromProps(resource, name, defaultDate, includeDay) { const dateValue = getDateValue(resource, name, defaultDate); const state = { day: null, month: 0, year: null }; if (dateValue) {
    if (includeDay) {
        state.day = dateValue.getDate();
    }
    state.month = dateValue.getMonth();
    state.year = dateValue.getFullYear();
} return state; }
export default function FloatingDatePicker({ className, clickToUnlock, defaultDate, defaultDay = 'first', direction = 'right', disabled, disabledText, error, handlePropagation, id, includeDay, label, maxYear, minDate, minYear, name, onChange, onClick, resource, resourceName, showDaysOfTheWeekHeader = false }) {
    const pickerRef = useRef(null);
    const initialState = getStateFromProps(resource, name, defaultDate, includeDay);
    const [day, setDay] = useState(initialState.day);
    const [month, setMonth] = useState(initialState.month);
    const [year, setYear] = useState(initialState.year); // Clear values when resource date is cleared
    useEffect(() => { const dateValue = getDateValue(resource, name, defaultDate); const valueNeedsClearing = !dateValue && year; if (valueNeedsClearing) {
        const newState = getStateFromProps(resource, name, defaultDate, includeDay);
        setDay(newState.day);
        setMonth(newState.month);
        setYear(newState.year);
    } }, [resource, name, defaultDate, includeDay, year]);
    const propagateDate = (newDay, newMonth, newYear) => { const currentDate = buildDate(newDay, newMonth, newYear, defaultDay); if (currentDate && pickerRef.current?.inputRef?.current) {
        const pickerInput = pickerRef.current.inputRef.current;
        window.myRIFT.helpers.triggerElementChange(pickerInput);
    } if (handlePropagation) {
        handlePropagation(name, currentDate);
    } if (onChange) {
        onChange({ [name]: currentDate });
    } };
    const handlePickerChange = partialState => { const newDay = partialState.day !== undefined ? partialState.day : day; const newMonth = partialState.month !== undefined ? partialState.month : month; const newYear = partialState.year !== undefined ? partialState.year : year; setDay(newDay); setMonth(newMonth); setYear(newYear); propagateDate(newDay, newMonth, newYear); };
    return /*#__PURE__*/ React.createElement(FloatingPicker, Object.assign({ value: dateInputValue(day, month, year), handlePropagation: handlePickerChange, options: datePickerDateOptions(day, month, year, minDate, minYear, maxYear, includeDay, showDaysOfTheWeekHeader), ref: pickerRef }, pick({ className, clickToUnlock, direction, disabled, disabledText, error, id, label, name, onClick, showDaysOfTheWeekHeader, resourceName }, ['className', 'clickToUnlock', 'direction', 'disabled', 'disabledText', 'error', 'id', 'label', 'name', 'onClick', 'showDaysOfTheWeekHeader', 'resourceName'])));
}
